import { useEffect } from "react";
import type { CellContext } from "@tanstack/react-table";
import type { CommunityMemberCharge } from "@circle-react/types/CommunityMemberCharge";
import { useChargeDetailsModal } from "@circle-react-shared/Paywalls/Modals/ChargeDetailsModal";
import { useDefaultColumnsToRender } from "@circle-react-shared/Paywalls/PaywallChargesList/Columns/hooks/useDefaultColumnsToRender";

interface ChargesData {
  charges?: CommunityMemberCharge[];
  setPage: (page: number) => void;
  totalCharges: number;
}

interface UsePaywallChargesListProps {
  chargesData: ChargesData;
}

export const usePaywallChargesList = ({
  chargesData,
}: UsePaywallChargesListProps) => {
  useEffect(() => {
    if (chargesData?.charges?.length === 0 && chargesData?.totalCharges > 0) {
      chargesData.setPage(1);
    }
  });

  const { defaultColumnsToRender } = useDefaultColumnsToRender();

  const onClickPagination = (currentPage: number) => {
    chargesData.setPage(currentPage);
  };

  const chargeDetailsModal = useChargeDetailsModal(null);
  const onClickColumn = (
    cellContext: CellContext<CommunityMemberCharge, unknown>,
  ) => {
    const {
      cell: {
        column: { id: columnName },
        row: { original: charge },
      },
    } = cellContext;

    if (columnName !== "customer") {
      void chargeDetailsModal.show({
        charge,
        shouldOpenAdminMemberEdit: true,
      });
    }
  };

  const columns = defaultColumnsToRender.map(column => ({
    ...column,
    onClick: onClickColumn,
  }));

  return {
    onClickPagination,
    columnsToRender: columns,
  };
};
